import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { KeyValue } from "../../../ui/KeyValue/KeyValue";
import { Select } from "../../../ui/Select/Select";

const options = [...Array(16).keys()].map((i) => i + 1);

export const PriceSelect: FunctionComponent<{
  className?: string;
  defaultValue: string;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}> = ({ className, defaultValue, name, onChange }) => {
  const { t } = useTranslation();
  return (
    <KeyValue>
      <>{t("priceSelect.quantity")}:</>
      <Select
        aria-label="selectedQuantity"
        className={className}
        defaultValue={defaultValue}
        key={defaultValue}
        name={name}
        onChange={onChange}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Select>
    </KeyValue>
  );
};
